import { useMutation } from "@tanstack/react-query";
import { validateLeatCredentials } from "../../api/bLeatApi";

export const useValidateLeat = () => {
  return useMutation({
    mutationKey: ["validate-leat"],
    mutationFn: (data) => validateLeatCredentials(data),
    onError: (error) => {
      console.error("Leat validation error details:", error.response || error);
    },
  });
};
